module.exports = __webpack_public_path__ + "fonts/flow-icons.51dfe69a.ttf";